// Site-wide translations. Keep keys flat per section.
// Languages: en (default), fr, de, es, pl

export const LANGUAGES = [
  { code: "en", label: "EN", name: "English" },
  { code: "fr", label: "FR", name: "Français" },
  { code: "de", label: "DE", name: "Deutsch" },
  { code: "es", label: "ES", name: "Español" },
  { code: "pl", label: "PL", name: "Polski" },
];

export const translations = {
  en: {
    nav: {
      home: "Home",
      about: "About",
      products: "Products",
      quality: "Quality",
      contact: "Contact",
      quote: "Request a Quote",
    },
    common: {
      explore: "Explore Products",
      requestQuote: "Request a Quote",
      getQuote: "Get Quote Now",
      requestQuoteShort: "Request Quote",
      submitRequest: "Submit a Request",
      viewAll: "View All Products",
      viewOnMap: "View on map",
      available: "Available",
      office: "Office",
      readMore: "Read more",
      learnMore: "Learn more",
      brand: "Original Motor Components",
    },
    hero: {
      overline: "Original Motor Components",
      title: "Engineering trust into every aftermarket component we import.",
      body: "OMC LTD leads the aftermarket automotive component industry across the UK and Europe — delivering innovative, sustainable and quality solutions sourced from world-class manufacturers in India.",
      whyOmc: "Why OMC",
      benefit1Title: "India → UK/EU",
      benefit1Body: "Direct sourcing, no middle channel",
      benefit2Title: "OEM-Grade",
      benefit2Body: "Original-equipment specification",
      benefit3Title: "Traceable",
      benefit3Body: "Lot-numbered on every shipment",
    },
    about: {
      overline: "About OMC LTD",
      title1: "Wholesale supplier of",
      titleItalic: "OEM-grade components",
      title2: "for the EU & UK aftermarket.",
      p1: "OMC LTD is a wholesale supplier of OEM-grade components that go in all kinds of off-highway and on-highway vehicles — primarily for the aftermarket. Every product undergoes rigorous quality and safety testing and is certified to be sold in EU and UK markets.",
      p2: "We operate sales offices in the UK, Benelux and France, alongside a warehouse in France — and we plan to expand our distribution network further into the EU in the near future.",
      p3prefix: "OMC LTD is an official partner for the aftermarket products of",
      p3suffix: "'s brake components and other OE parts — the aftermarket division for the UK and Europe. We also source from manufacturers with a long track record in the industry.",
      statRegistered: "Registered",
      statOffices: "Offices",
      statWarehouse: "Warehouse",
      statSourcing: "Sourcing",
      statOfficesSub: "UK · Benelux · France",
      statWarehouseSub: "France",
      statSourcingSub: "OEM-grade",
      bannerCountries: "UK · Benelux · France",
      bannerSub: "Aftermarket across Europe",
    },
    why: {
      overline: "Why Choose Us",
      title1: "Why",
      titleItalic: "Choose Us",
      subtitle: "Built around five reasons that matter to every aftermarket buyer — from an independent garage in the UK to a fleet operator in Gent.",
      r1Title: "Strong Logistics",
      r1Text: "Robust import-export operations with established freight partners across the UK, Benelux and France.",
      r2Title: "Quality Certified",
      r2Text: "Every product is OEM-grade and certified for sale across UK and EU markets — rigorously tested for quality and safety.",
      r3Title: "Wide Distribution",
      r3Text: "Sales offices in UK, Benelux and France with a France warehouse — eager to serve resellers and fleets across Europe.",
      r4Title: "Competitive Price",
      r4Text: "Direct sourcing from established manufacturers means transparent wholesale pricing at every volume tier.",
      r5Title: "Low Lead Times",
      r5Text: "Local European stock and disciplined logistics keep delivery lead times short — exactly when your workshop needs parts.",
    },
    range: {
      overline: "Product Range",
      title1: "Our",
      titleItalic: "Product Range",
      subtitle: "Four divisions, one accountable channel — OEM-grade automotive components and workshop equipment for the UK & Europe aftermarket.",
      div1Title: "Rane Brake Components Division",
      div1Short: "OEM-grade brake pads, linings, railway brake blocks, sintered pads, clutch facings and disc pads — from Rane Group.",
      div2Title: "Rane Other Parts & Components",
      div2Short: "Complete aftermarket range for the engine, gear pumps — valves, pumps, gaskets, mounts and steering hardware.",
      div3Title: "Industrial & Off-Road Tyres",
      div3Short: "Industrial & material-handling tyres plus off-road / OTR & agri tyres from leading global brands.",
      div4Title: "Wheel Alignment, Balancing & Tyre Fitting Machines",
      div4Short: "World-class wheel alignment machines, balancing machines, tyre fitting machines and accessories for modern workshops.",
    },
    partners: {
      overline: "Our Network",
      title1: "Our Partners &",
      titleItalic: "Suppliers",
      subtitle: "Three trusted partners power our aftermarket programme — all rooted in OEM-grade quality.",
    },
    finalCta: {
      overline: "Ready to place a business quote?",
      title1: "Wholesale prices, in the quantities you need,",
      titleItalic: "at OEM-grade quality.",
    },
    contact: {
      stepLabel: "Step one · Step two",
      submitTitle: "Submit a request first.",
      submitBodyA: "If our form doesn't reach you for any reason, email us at",
      submitBodyB: "or",
      submitBodyC: "for a faster response.",
      labelPrimaryEmail: "Primary Email",
      labelSisterBusiness: "Sister Business",
      labelUkPhone: "UK Phone",
      labelFrPhone: "France Phone",
      labelBePhone: "Belgium Phone",
      subFastest: "Fastest written channel",
      sub1eo: "Via 1eo.uk channel",
      subUk: "United Kingdom",
      subFr: "France",
      subBe: "Belgium",
      ourOffices: "Our Offices",
      threeLocations1: "Three locations,",
      threeLocationsItalic: "one company.",
      ukTitle: "Coventry, United Kingdom",
      frTitle: "Pau, France",
      beTitle: "Gent, Belgium",
    },
    footer: {
      tagline: "Wholesale supplier of OEM-grade automotive components for the UK & EU aftermarket. Official partner for Rane brake components and aftermarket OE parts.",
      ukOffice: "UK Office",
      beOffice: "Belgium Office",
      frOffice: "France Office",
      sitemap: "Sitemap",
      regions: "UK · Benelux · France",
      rights: "All rights reserved",
    },
    pages: {
      aboutOverline: "About",
      aboutTitle: "Original Motor Components.",
      aboutSubtitle: "OMC LTD is a UK-registered importer and distributor of OEM-grade automotive components, serving the UK & Europe aftermarket.",
      rangeOverline: "Products",
      rangeTitlePre: "Our",
      rangeTitleItalic: "Product Range",
      rangeSubtitle: "Three divisions of OEM-grade automotive components — brake systems, engine & chassis parts, tyres & workshop equipment — serviced through the UK & Europe aftermarket.",
      contactOverline: "Contact",
      contactTitlePre: "Drop us",
      contactTitleItalic: "a line",
      contactSubtitle: "UK & Europe aftermarket enquiries are handled the same business day. Choose the channel that suits you.",
      qualityOverline: "Quality",
      qualityTitlePre: "Quality is a",
      qualityTitleItalic: "chain",
      qualityTitlePost: ", not a slogan.",
      qualitySubtitle: "Five disciplined stages connect the manufacturing plant to your purchase order — every step lot-numbered, audited and accountable.",
      quoteOverline: "Request a Quote",
      quoteTitlePre: "Tell us about your",
      quoteTitleItalic: "requirement",
      quoteSubtitle: "Share part details and quantity. We'll respond within one business day with stock availability, lead time and bulk-tier pricing — no obligation.",
      breadcrumbHome: "Home",
    },
  },

  fr: {
    nav: {
      home: "Accueil",
      about: "À propos",
      products: "Produits",
      quality: "Qualité",
      contact: "Contact",
      quote: "Demander un devis",
    },
    common: {
      explore: "Voir les produits",
      requestQuote: "Demander un devis",
      getQuote: "Obtenir un devis",
      requestQuoteShort: "Devis",
      submitRequest: "Envoyer une demande",
      viewAll: "Voir tous les produits",
      viewOnMap: "Voir sur la carte",
      available: "Disponible",
      office: "Bureau",
      readMore: "En savoir plus",
      learnMore: "En savoir plus",
      brand: "Original Motor Components",
    },
    hero: {
      overline: "Original Motor Components",
      title: "La confiance d'ingénierie dans chaque composant aftermarket que nous importons.",
      body: "OMC LTD est leader du marché des composants automobiles aftermarket au Royaume-Uni et en Europe — proposant des solutions innovantes, durables et de qualité issues de fabricants de classe mondiale en Inde.",
      whyOmc: "Pourquoi OMC",
      benefit1Title: "Inde → UK/UE",
      benefit1Body: "Approvisionnement direct, sans intermédiaire",
      benefit2Title: "Qualité OEM",
      benefit2Body: "Spécification équipement d'origine",
      benefit3Title: "Traçable",
      benefit3Body: "Numéro de lot sur chaque expédition",
    },
    about: {
      overline: "À propos d'OMC LTD",
      title1: "Fournisseur en gros de",
      titleItalic: "composants de qualité OEM",
      title2: "pour l'aftermarket UE & UK.",
      p1: "OMC LTD est un fournisseur en gros de composants de qualité OEM destinés à toutes sortes de véhicules routiers et tout-terrain — principalement pour l'aftermarket. Chaque produit subit des essais rigoureux de qualité et de sécurité et est certifié pour la vente sur les marchés UE et UK.",
      p2: "Nous opérons des bureaux commerciaux au Royaume-Uni, au Benelux et en France, avec un entrepôt en France — et nous prévoyons d'étendre notre réseau de distribution plus loin dans l'UE.",
      p3prefix: "OMC LTD est partenaire officiel pour les produits aftermarket de",
      p3suffix: " — composants de freinage et autres pièces OE, division aftermarket pour le UK et l'Europe. Nous sourçons également auprès de fabricants reconnus dans l'industrie.",
      statRegistered: "Enregistrée",
      statOffices: "Bureaux",
      statWarehouse: "Entrepôt",
      statSourcing: "Sourcing",
      statOfficesSub: "UK · Benelux · France",
      statWarehouseSub: "France",
      statSourcingSub: "Qualité OEM",
      bannerCountries: "UK · Benelux · France",
      bannerSub: "Aftermarket en Europe",
    },
    why: {
      overline: "Pourquoi nous choisir",
      title1: "Pourquoi",
      titleItalic: "nous choisir",
      subtitle: "Cinq raisons qui comptent pour tout acheteur aftermarket — d'un garage indépendant au Royaume-Uni à un opérateur de flotte à Gand.",
      r1Title: "Logistique solide",
      r1Text: "Opérations d'import-export robustes avec des partenaires de fret établis au Royaume-Uni, au Benelux et en France.",
      r2Title: "Qualité certifiée",
      r2Text: "Chaque produit est de qualité OEM et certifié pour la vente sur les marchés UK et UE — testé rigoureusement.",
      r3Title: "Large distribution",
      r3Text: "Bureaux commerciaux au UK, Benelux et France avec un entrepôt français — au service des revendeurs et flottes en Europe.",
      r4Title: "Prix compétitifs",
      r4Text: "Sourcing direct chez les fabricants établis : prix de gros transparents à tous les volumes.",
      r5Title: "Délais courts",
      r5Text: "Stock européen local et logistique rigoureuse — des délais de livraison courts quand votre atelier a besoin de pièces.",
    },
    range: {
      overline: "Gamme de produits",
      title1: "Notre",
      titleItalic: "gamme de produits",
      subtitle: "Quatre divisions, un canal responsable — composants automobiles de qualité OEM et équipement d'atelier pour l'aftermarket UK & Europe.",
      div1Title: "Division Composants de Frein Rane",
      div1Short: "Plaquettes, garnitures, blocs-frein ferroviaires, plaquettes frittées, garnitures d'embrayage et plaquettes de disque qualité OEM — par Rane Group.",
      div2Title: "Autres pièces & composants Rane",
      div2Short: "Gamme aftermarket complète pour le moteur, pompes — soupapes, pompes, joints, supports et direction.",
      div3Title: "Pneus industriels & tout-terrain",
      div3Short: "Pneus industriels & de manutention plus pneus tout-terrain / OTR & agricoles des marques mondiales.",
      div4Title: "Machines d'alignement, équilibrage & montage pneus",
      div4Short: "Aligneuses, équilibreuses, démonte-pneus et accessoires de classe mondiale pour ateliers modernes.",
    },
    partners: {
      overline: "Notre réseau",
      title1: "Nos partenaires &",
      titleItalic: "fournisseurs",
      subtitle: "Trois partenaires de confiance alimentent notre programme aftermarket — tous ancrés dans la qualité OEM.",
    },
    finalCta: {
      overline: "Prêt à passer un devis professionnel ?",
      title1: "Prix de gros, dans les quantités dont vous avez besoin,",
      titleItalic: "qualité OEM.",
    },
    contact: {
      stepLabel: "Étape un · Étape deux",
      submitTitle: "Soumettez d'abord une demande.",
      submitBodyA: "Si notre formulaire ne vous parvient pas, écrivez-nous à",
      submitBodyB: "ou",
      submitBodyC: "pour une réponse plus rapide.",
      labelPrimaryEmail: "E-mail principal",
      labelSisterBusiness: "Société sœur",
      labelUkPhone: "Téléphone UK",
      labelFrPhone: "Téléphone France",
      labelBePhone: "Téléphone Belgique",
      subFastest: "Canal écrit le plus rapide",
      sub1eo: "Via le canal 1eo.uk",
      subUk: "Royaume-Uni",
      subFr: "France",
      subBe: "Belgique",
      ourOffices: "Nos bureaux",
      threeLocations1: "Trois sites,",
      threeLocationsItalic: "une entreprise.",
      ukTitle: "Coventry, Royaume-Uni",
      frTitle: "Pau, France",
      beTitle: "Gand, Belgique",
    },
    footer: {
      tagline: "Fournisseur en gros de composants automobiles de qualité OEM pour l'aftermarket UK & UE. Partenaire officiel des composants de frein Rane et pièces OE aftermarket.",
      ukOffice: "Bureau UK",
      beOffice: "Bureau Belgique",
      frOffice: "Bureau France",
      sitemap: "Plan du site",
      regions: "UK · Benelux · France",
      rights: "Tous droits réservés",
    },
    pages: {
      aboutOverline: "À propos",
      aboutTitle: "Original Motor Components.",
      aboutSubtitle: "OMC LTD est un importateur et distributeur enregistré au Royaume-Uni de composants automobiles de qualité OEM, au service de l'aftermarket UK & Europe.",
      rangeOverline: "Produits",
      rangeTitlePre: "Notre",
      rangeTitleItalic: "gamme de produits",
      rangeSubtitle: "Trois divisions de composants automobiles de qualité OEM — systèmes de freinage, pièces moteur & châssis, pneus & équipement d'atelier — pour l'aftermarket UK & Europe.",
      contactOverline: "Contact",
      contactTitlePre: "Écrivez-nous",
      contactTitleItalic: "un message",
      contactSubtitle: "Les demandes aftermarket UK & Europe sont traitées le jour même. Choisissez le canal qui vous convient.",
      qualityOverline: "Qualité",
      qualityTitlePre: "La qualité est une",
      qualityTitleItalic: "chaîne",
      qualityTitlePost: ", pas un slogan.",
      qualitySubtitle: "Cinq étapes disciplinées relient l'usine à votre bon de commande — chaque étape numérotée, auditée et responsable.",
      quoteOverline: "Demander un devis",
      quoteTitlePre: "Parlez-nous de votre",
      quoteTitleItalic: "besoin",
      quoteSubtitle: "Partagez détails et quantités. Nous répondons en un jour ouvré avec disponibilité, délai et tarif gros — sans engagement.",
      breadcrumbHome: "Accueil",
    },
  },

  de: {
    nav: {
      home: "Startseite",
      about: "Über uns",
      products: "Produkte",
      quality: "Qualität",
      contact: "Kontakt",
      quote: "Angebot anfordern",
    },
    common: {
      explore: "Produkte entdecken",
      requestQuote: "Angebot anfordern",
      getQuote: "Angebot erhalten",
      requestQuoteShort: "Angebot",
      submitRequest: "Anfrage senden",
      viewAll: "Alle Produkte anzeigen",
      viewOnMap: "Auf Karte ansehen",
      available: "Verfügbar",
      office: "Büro",
      readMore: "Mehr erfahren",
      learnMore: "Mehr erfahren",
      brand: "Original Motor Components",
    },
    hero: {
      overline: "Original Motor Components",
      title: "Vertrauen in jedes Aftermarket-Teil, das wir importieren.",
      body: "OMC LTD führt die Aftermarket-Automobilbranche in Großbritannien und Europa an — mit innovativen, nachhaltigen und qualitativ hochwertigen Lösungen von erstklassigen Herstellern in Indien.",
      whyOmc: "Warum OMC",
      benefit1Title: "Indien → UK/EU",
      benefit1Body: "Direkter Bezug, kein Zwischenhandel",
      benefit2Title: "OEM-Qualität",
      benefit2Body: "Originalteile-Spezifikation",
      benefit3Title: "Rückverfolgbar",
      benefit3Body: "Chargennummer auf jeder Lieferung",
    },
    about: {
      overline: "Über OMC LTD",
      title1: "Großhändler für",
      titleItalic: "OEM-Komponenten",
      title2: "im EU- und UK-Aftermarket.",
      p1: "OMC LTD ist ein Großhändler für OEM-Komponenten für alle Arten von Straßen- und Geländefahrzeugen — vorwiegend für den Aftermarket. Jedes Produkt durchläuft strenge Qualitäts- und Sicherheitsprüfungen und ist für den Verkauf in den EU- und UK-Märkten zertifiziert.",
      p2: "Wir betreiben Vertriebsbüros in UK, Benelux und Frankreich sowie ein Lager in Frankreich — und planen, unser Vertriebsnetz weiter in der EU auszubauen.",
      p3prefix: "OMC LTD ist offizieller Partner für die Aftermarket-Produkte von",
      p3suffix: " — Bremsenkomponenten und andere OE-Teile, die Aftermarket-Sparte für UK und Europa. Wir beziehen auch von Herstellern mit langjähriger Branchenerfahrung.",
      statRegistered: "Registriert",
      statOffices: "Büros",
      statWarehouse: "Lager",
      statSourcing: "Bezug",
      statOfficesSub: "UK · Benelux · Frankreich",
      statWarehouseSub: "Frankreich",
      statSourcingSub: "OEM-Qualität",
      bannerCountries: "UK · Benelux · Frankreich",
      bannerSub: "Aftermarket in Europa",
    },
    why: {
      overline: "Warum wir",
      title1: "Warum",
      titleItalic: "uns wählen",
      subtitle: "Fünf Gründe, die für jeden Aftermarket-Käufer zählen — von der unabhängigen Werkstatt in Großbritannien bis zum Flottenbetreiber in Gent.",
      r1Title: "Starke Logistik",
      r1Text: "Robuster Import-Export mit etablierten Frachtpartnern in UK, Benelux und Frankreich.",
      r2Title: "Qualität zertifiziert",
      r2Text: "Jedes Produkt ist OEM-Qualität und für UK- und EU-Märkte zertifiziert — streng auf Qualität und Sicherheit geprüft.",
      r3Title: "Breite Distribution",
      r3Text: "Vertriebsbüros in UK, Benelux und Frankreich mit französischem Lager — für Händler und Flotten in Europa.",
      r4Title: "Wettbewerbsfähige Preise",
      r4Text: "Direktbezug von etablierten Herstellern: transparente Großhandelspreise auf jeder Volumenstufe.",
      r5Title: "Kurze Lieferzeiten",
      r5Text: "Lokaler europäischer Bestand und disziplinierte Logistik — kurze Lieferzeiten, wenn Ihre Werkstatt Teile braucht.",
    },
    range: {
      overline: "Produktpalette",
      title1: "Unsere",
      titleItalic: "Produktpalette",
      subtitle: "Vier Sparten, ein verantwortlicher Kanal — OEM-Automobilteile und Werkstattausrüstung für den UK- und Europa-Aftermarket.",
      div1Title: "Rane Bremsenkomponenten-Sparte",
      div1Short: "Bremsbeläge, -beläge, Eisenbahn-Bremsklötze, gesinterte Beläge, Kupplungsbeläge und Scheibenbeläge in OEM-Qualität — von Rane Group.",
      div2Title: "Rane Weitere Teile & Komponenten",
      div2Short: "Komplettes Aftermarket-Angebot für Motor, Pumpen — Ventile, Pumpen, Dichtungen, Lager und Lenkungsteile.",
      div3Title: "Industrie- & Geländereifen",
      div3Short: "Industrie- & Logistikreifen sowie Gelände- / OTR- & Agrarreifen führender Weltmarken.",
      div4Title: "Achsvermessungs-, Auswucht- & Reifenmontage-Maschinen",
      div4Short: "Spitzenklasse Achsvermessung, Auswuchtmaschinen, Reifenmontiermaschinen und Zubehör für moderne Werkstätten.",
    },
    partners: {
      overline: "Unser Netzwerk",
      title1: "Unsere Partner &",
      titleItalic: "Lieferanten",
      subtitle: "Drei vertrauenswürdige Partner tragen unser Aftermarket-Programm — alle mit OEM-Qualität verwurzelt.",
    },
    finalCta: {
      overline: "Bereit für ein Geschäftsangebot?",
      title1: "Großhandelspreise, in den gewünschten Mengen,",
      titleItalic: "in OEM-Qualität.",
    },
    contact: {
      stepLabel: "Schritt 1 · Schritt 2",
      submitTitle: "Bitte zuerst eine Anfrage senden.",
      submitBodyA: "Falls unser Formular nicht ankommt, schreiben Sie an",
      submitBodyB: "oder",
      submitBodyC: "für eine schnellere Antwort.",
      labelPrimaryEmail: "Haupt-E-Mail",
      labelSisterBusiness: "Schwesterfirma",
      labelUkPhone: "UK Telefon",
      labelFrPhone: "Frankreich Telefon",
      labelBePhone: "Belgien Telefon",
      subFastest: "Schnellster Schriftkanal",
      sub1eo: "Über 1eo.uk Kanal",
      subUk: "Vereinigtes Königreich",
      subFr: "Frankreich",
      subBe: "Belgien",
      ourOffices: "Unsere Standorte",
      threeLocations1: "Drei Standorte,",
      threeLocationsItalic: "ein Unternehmen.",
      ukTitle: "Coventry, Vereinigtes Königreich",
      frTitle: "Pau, Frankreich",
      beTitle: "Gent, Belgien",
    },
    footer: {
      tagline: "Großhändler für OEM-Automobilkomponenten für den UK- & EU-Aftermarket. Offizieller Partner für Rane-Bremsenkomponenten und Aftermarket-OE-Teile.",
      ukOffice: "UK Büro",
      beOffice: "Belgien Büro",
      frOffice: "Frankreich Büro",
      sitemap: "Seitenübersicht",
      regions: "UK · Benelux · Frankreich",
      rights: "Alle Rechte vorbehalten",
    },
    pages: {
      aboutOverline: "Über uns",
      aboutTitle: "Original Motor Components.",
      aboutSubtitle: "OMC LTD ist ein in Großbritannien registrierter Importeur und Distributor von OEM-Automobilkomponenten für den UK- & Europa-Aftermarket.",
      rangeOverline: "Produkte",
      rangeTitlePre: "Unsere",
      rangeTitleItalic: "Produktpalette",
      rangeSubtitle: "Drei Sparten von OEM-Automobilkomponenten — Bremssysteme, Motor- & Fahrwerksteile, Reifen & Werkstattausrüstung — für den UK- & Europa-Aftermarket.",
      contactOverline: "Kontakt",
      contactTitlePre: "Schreiben Sie",
      contactTitleItalic: "uns",
      contactSubtitle: "UK- & Europa-Aftermarket-Anfragen werden am selben Werktag bearbeitet. Wählen Sie den passenden Kanal.",
      qualityOverline: "Qualität",
      qualityTitlePre: "Qualität ist eine",
      qualityTitleItalic: "Kette",
      qualityTitlePost: ", kein Slogan.",
      qualitySubtitle: "Fünf disziplinierte Stufen verbinden Werk und Bestellung — jeder Schritt mit Chargennummer, geprüft und nachvollziehbar.",
      quoteOverline: "Angebot anfordern",
      quoteTitlePre: "Beschreiben Sie Ihren",
      quoteTitleItalic: "Bedarf",
      quoteSubtitle: "Teilen Sie Teile und Mengen mit. Wir antworten innerhalb eines Werktags mit Verfügbarkeit, Lieferzeit und Großmengenpreis — unverbindlich.",
      breadcrumbHome: "Startseite",
    },
  },

  es: {
    nav: {
      home: "Inicio",
      about: "Nosotros",
      products: "Productos",
      quality: "Calidad",
      contact: "Contacto",
      quote: "Solicitar presupuesto",
    },
    common: {
      explore: "Ver productos",
      requestQuote: "Solicitar presupuesto",
      getQuote: "Obtener presupuesto",
      requestQuoteShort: "Presupuesto",
      submitRequest: "Enviar solicitud",
      viewAll: "Ver todos los productos",
      viewOnMap: "Ver en el mapa",
      available: "Disponible",
      office: "Oficina",
      readMore: "Saber más",
      learnMore: "Más información",
      brand: "Original Motor Components",
    },
    hero: {
      overline: "Original Motor Components",
      title: "Confianza de ingeniería en cada componente aftermarket que importamos.",
      body: "OMC LTD lidera la industria de componentes automotrices aftermarket en el Reino Unido y Europa — ofreciendo soluciones innovadoras, sostenibles y de calidad procedentes de fabricantes de clase mundial en India.",
      whyOmc: "Por qué OMC",
      benefit1Title: "India → UK/UE",
      benefit1Body: "Suministro directo, sin intermediarios",
      benefit2Title: "Calidad OEM",
      benefit2Body: "Especificación de equipo original",
      benefit3Title: "Trazable",
      benefit3Body: "Número de lote en cada envío",
    },
    about: {
      overline: "Sobre OMC LTD",
      title1: "Proveedor mayorista de",
      titleItalic: "componentes calidad OEM",
      title2: "para el aftermarket UE y UK.",
      p1: "OMC LTD es proveedor mayorista de componentes calidad OEM para todo tipo de vehículos de carretera y todoterreno — principalmente para aftermarket. Cada producto pasa rigurosos controles de calidad y seguridad y está certificado para venta en UE y UK.",
      p2: "Operamos oficinas comerciales en UK, Benelux y Francia, junto a un almacén en Francia — y planeamos expandir nuestra red de distribución más en la UE.",
      p3prefix: "OMC LTD es socio oficial de los productos aftermarket de",
      p3suffix: " — componentes de freno y otras piezas OE, división aftermarket para UK y Europa. También compramos a fabricantes con larga trayectoria en el sector.",
      statRegistered: "Registrada",
      statOffices: "Oficinas",
      statWarehouse: "Almacén",
      statSourcing: "Suministro",
      statOfficesSub: "UK · Benelux · Francia",
      statWarehouseSub: "Francia",
      statSourcingSub: "Calidad OEM",
      bannerCountries: "UK · Benelux · Francia",
      bannerSub: "Aftermarket en Europa",
    },
    why: {
      overline: "Por qué elegirnos",
      title1: "Por qué",
      titleItalic: "elegirnos",
      subtitle: "Cinco razones que importan a todo comprador aftermarket — desde un taller independiente en Reino Unido hasta un operador de flota en Gante.",
      r1Title: "Logística sólida",
      r1Text: "Operaciones import-export robustas con socios de transporte establecidos en UK, Benelux y Francia.",
      r2Title: "Calidad certificada",
      r2Text: "Cada producto es calidad OEM y está certificado para venta en mercados UK y UE — probado rigurosamente.",
      r3Title: "Amplia distribución",
      r3Text: "Oficinas comerciales en UK, Benelux y Francia con almacén francés — al servicio de distribuidores y flotas en Europa.",
      r4Title: "Precios competitivos",
      r4Text: "Suministro directo de fabricantes establecidos: precios mayoristas transparentes en todo volumen.",
      r5Title: "Plazos cortos",
      r5Text: "Stock europeo local y logística disciplinada — plazos de entrega cortos cuando su taller necesita piezas.",
    },
    range: {
      overline: "Gama de productos",
      title1: "Nuestra",
      titleItalic: "gama de productos",
      subtitle: "Cuatro divisiones, un canal responsable — componentes automotrices calidad OEM y equipamiento de taller para el aftermarket UK & Europa.",
      div1Title: "División Componentes de Freno Rane",
      div1Short: "Pastillas, forros, bloques de freno ferroviarios, pastillas sinterizadas, forros de embrague y pastillas de disco calidad OEM — de Rane Group.",
      div2Title: "Otros componentes y piezas Rane",
      div2Short: "Gama aftermarket completa para motor, bombas — válvulas, bombas, juntas, soportes y dirección.",
      div3Title: "Neumáticos industriales y todoterreno",
      div3Short: "Neumáticos industriales y de manipulación más todoterreno / OTR y agrícolas de marcas mundiales.",
      div4Title: "Máquinas de alineación, equilibrado y montaje de neumáticos",
      div4Short: "Alineadoras, equilibradoras, desmontadoras y accesorios de clase mundial para talleres modernos.",
    },
    partners: {
      overline: "Nuestra red",
      title1: "Nuestros socios y",
      titleItalic: "proveedores",
      subtitle: "Tres socios de confianza impulsan nuestro programa aftermarket — todos arraigados en calidad OEM.",
    },
    finalCta: {
      overline: "¿Listo para un presupuesto empresarial?",
      title1: "Precios mayoristas, en las cantidades que necesita,",
      titleItalic: "con calidad OEM.",
    },
    contact: {
      stepLabel: "Paso uno · Paso dos",
      submitTitle: "Envíe primero una solicitud.",
      submitBodyA: "Si nuestro formulario no le llega, escríbanos a",
      submitBodyB: "o",
      submitBodyC: "para una respuesta más rápida.",
      labelPrimaryEmail: "Email principal",
      labelSisterBusiness: "Empresa hermana",
      labelUkPhone: "Teléfono UK",
      labelFrPhone: "Teléfono Francia",
      labelBePhone: "Teléfono Bélgica",
      subFastest: "Canal escrito más rápido",
      sub1eo: "Por canal 1eo.uk",
      subUk: "Reino Unido",
      subFr: "Francia",
      subBe: "Bélgica",
      ourOffices: "Nuestras oficinas",
      threeLocations1: "Tres ubicaciones,",
      threeLocationsItalic: "una empresa.",
      ukTitle: "Coventry, Reino Unido",
      frTitle: "Pau, Francia",
      beTitle: "Gante, Bélgica",
    },
    footer: {
      tagline: "Proveedor mayorista de componentes automotrices calidad OEM para el aftermarket UK & UE. Socio oficial de componentes de freno Rane y piezas OE aftermarket.",
      ukOffice: "Oficina UK",
      beOffice: "Oficina Bélgica",
      frOffice: "Oficina Francia",
      sitemap: "Mapa del sitio",
      regions: "UK · Benelux · Francia",
      rights: "Todos los derechos reservados",
    },
    pages: {
      aboutOverline: "Nosotros",
      aboutTitle: "Original Motor Components.",
      aboutSubtitle: "OMC LTD es un importador y distribuidor registrado en Reino Unido de componentes automotrices calidad OEM, al servicio del aftermarket UK & Europa.",
      rangeOverline: "Productos",
      rangeTitlePre: "Nuestra",
      rangeTitleItalic: "gama de productos",
      rangeSubtitle: "Tres divisiones de componentes automotrices calidad OEM — sistemas de frenado, piezas de motor y chasis, neumáticos y equipo de taller — para el aftermarket UK & Europa.",
      contactOverline: "Contacto",
      contactTitlePre: "Escríbanos",
      contactTitleItalic: "un mensaje",
      contactSubtitle: "Las consultas aftermarket UK & Europa se atienden el mismo día. Elija el canal que prefiera.",
      qualityOverline: "Calidad",
      qualityTitlePre: "La calidad es una",
      qualityTitleItalic: "cadena",
      qualityTitlePost: ", no un eslogan.",
      qualitySubtitle: "Cinco etapas disciplinadas conectan la planta con su pedido — cada paso con número de lote, auditado y responsable.",
      quoteOverline: "Solicitar presupuesto",
      quoteTitlePre: "Cuéntenos su",
      quoteTitleItalic: "requerimiento",
      quoteSubtitle: "Comparta piezas y cantidades. Responderemos en un día laborable con disponibilidad, plazo y precio mayorista — sin compromiso.",
      breadcrumbHome: "Inicio",
    },
  },

  pl: {
    nav: {
      home: "Strona główna",
      about: "O nas",
      products: "Produkty",
      quality: "Jakość",
      contact: "Kontakt",
      quote: "Zapytaj o wycenę",
    },
    common: {
      explore: "Zobacz produkty",
      requestQuote: "Zapytaj o wycenę",
      getQuote: "Otrzymaj wycenę",
      requestQuoteShort: "Wycena",
      submitRequest: "Wyślij zapytanie",
      viewAll: "Zobacz wszystkie produkty",
      viewOnMap: "Zobacz na mapie",
      available: "Dostępne",
      office: "Biuro",
      readMore: "Czytaj więcej",
      learnMore: "Dowiedz się więcej",
      brand: "Original Motor Components",
    },
    hero: {
      overline: "Original Motor Components",
      title: "Inżynieryjne zaufanie w każdym importowanym przez nas komponencie aftermarket.",
      body: "OMC LTD jest liderem branży części aftermarket w Wielkiej Brytanii i Europie — dostarczamy innowacyjne, zrównoważone i wysokiej jakości rozwiązania od światowej klasy producentów w Indiach.",
      whyOmc: "Dlaczego OMC",
      benefit1Title: "Indie → UK/UE",
      benefit1Body: "Bezpośrednie źródło, bez pośredników",
      benefit2Title: "Jakość OEM",
      benefit2Body: "Specyfikacja oryginalnego wyposażenia",
      benefit3Title: "Identyfikowalność",
      benefit3Body: "Numer partii na każdej dostawie",
    },
    about: {
      overline: "O OMC LTD",
      title1: "Hurtowy dostawca",
      titleItalic: "komponentów jakości OEM",
      title2: "dla aftermarketu UE i UK.",
      p1: "OMC LTD to hurtowy dostawca komponentów jakości OEM do wszelkiego rodzaju pojazdów drogowych i terenowych — głównie na aftermarket. Każdy produkt przechodzi rygorystyczne badania jakości i bezpieczeństwa i jest certyfikowany do sprzedaży na rynkach UE i UK.",
      p2: "Prowadzimy biura handlowe w UK, Beneluksie i Francji oraz magazyn we Francji — i planujemy dalsze rozszerzanie sieci dystrybucji w UE.",
      p3prefix: "OMC LTD jest oficjalnym partnerem produktów aftermarket firmy",
      p3suffix: " — komponenty hamulcowe i inne części OE, dywizja aftermarket dla UK i Europy. Współpracujemy też z producentami o długiej historii w branży.",
      statRegistered: "Zarejestrowana",
      statOffices: "Biura",
      statWarehouse: "Magazyn",
      statSourcing: "Źródło",
      statOfficesSub: "UK · Benelux · Francja",
      statWarehouseSub: "Francja",
      statSourcingSub: "Jakość OEM",
      bannerCountries: "UK · Benelux · Francja",
      bannerSub: "Aftermarket w Europie",
    },
    why: {
      overline: "Dlaczego my",
      title1: "Dlaczego",
      titleItalic: "warto nas wybrać",
      subtitle: "Pięć powodów ważnych dla każdego kupującego aftermarket — od niezależnego warsztatu w UK po operatora floty w Gandawie.",
      r1Title: "Silna logistyka",
      r1Text: "Solidne operacje import-eksport z ustalonymi partnerami transportowymi w UK, Beneluksie i Francji.",
      r2Title: "Certyfikowana jakość",
      r2Text: "Każdy produkt to jakość OEM, certyfikowany do sprzedaży na rynkach UK i UE — rygorystycznie testowany.",
      r3Title: "Szeroka dystrybucja",
      r3Text: "Biura w UK, Beneluksie i Francji oraz magazyn we Francji — dla dystrybutorów i flot w Europie.",
      r4Title: "Konkurencyjne ceny",
      r4Text: "Bezpośrednie źródło u producentów: przejrzyste ceny hurtowe na każdym poziomie ilościowym.",
      r5Title: "Krótkie terminy",
      r5Text: "Lokalny europejski magazyn i sprawna logistyka — krótkie terminy dostaw, gdy warsztat potrzebuje części.",
    },
    range: {
      overline: "Asortyment",
      title1: "Nasz",
      titleItalic: "asortyment",
      subtitle: "Cztery dywizje, jeden odpowiedzialny kanał — komponenty samochodowe jakości OEM i wyposażenie warsztatowe na aftermarket UK i Europy.",
      div1Title: "Dywizja Hamulcowa Rane",
      div1Short: "Klocki, okładziny, kolejowe bloki hamulcowe, klocki spiekane, okładziny sprzęgłowe i klocki tarczowe jakości OEM — od Rane Group.",
      div2Title: "Inne części i komponenty Rane",
      div2Short: "Pełna gama aftermarket: silnik, pompy — zawory, pompy, uszczelki, łożyska i układ kierowniczy.",
      div3Title: "Opony przemysłowe i terenowe",
      div3Short: "Opony przemysłowe i magazynowe oraz terenowe / OTR i rolnicze czołowych marek światowych.",
      div4Title: "Maszyny do geometrii, wyważania i montażu opon",
      div4Short: "Światowej klasy urządzenia do geometrii, wyważarki, montażownice i akcesoria dla nowoczesnych warsztatów.",
    },
    partners: {
      overline: "Nasza sieć",
      title1: "Nasi partnerzy i",
      titleItalic: "dostawcy",
      subtitle: "Trzech zaufanych partnerów napędza nasz program aftermarket — wszyscy zakorzenieni w jakości OEM.",
    },
    finalCta: {
      overline: "Gotowy na zapytanie biznesowe?",
      title1: "Ceny hurtowe, w ilościach, których potrzebujesz,",
      titleItalic: "w jakości OEM.",
    },
    contact: {
      stepLabel: "Krok pierwszy · Krok drugi",
      submitTitle: "Najpierw wyślij zapytanie.",
      submitBodyA: "Jeśli formularz nie zadziała, napisz do nas na",
      submitBodyB: "lub",
      submitBodyC: "aby uzyskać szybszą odpowiedź.",
      labelPrimaryEmail: "E-mail główny",
      labelSisterBusiness: "Firma siostrzana",
      labelUkPhone: "Telefon UK",
      labelFrPhone: "Telefon Francja",
      labelBePhone: "Telefon Belgia",
      subFastest: "Najszybszy kanał pisemny",
      sub1eo: "Przez kanał 1eo.uk",
      subUk: "Wielka Brytania",
      subFr: "Francja",
      subBe: "Belgia",
      ourOffices: "Nasze biura",
      threeLocations1: "Trzy lokalizacje,",
      threeLocationsItalic: "jedna firma.",
      ukTitle: "Coventry, Wielka Brytania",
      frTitle: "Pau, Francja",
      beTitle: "Gandawa, Belgia",
    },
    footer: {
      tagline: "Hurtowy dostawca komponentów samochodowych jakości OEM na aftermarket UK i UE. Oficjalny partner komponentów hamulcowych Rane i części OE aftermarket.",
      ukOffice: "Biuro UK",
      beOffice: "Biuro Belgia",
      frOffice: "Biuro Francja",
      sitemap: "Mapa strony",
      regions: "UK · Benelux · Francja",
      rights: "Wszelkie prawa zastrzeżone",
    },
    pages: {
      aboutOverline: "O nas",
      aboutTitle: "Original Motor Components.",
      aboutSubtitle: "OMC LTD to zarejestrowany w UK importer i dystrybutor komponentów samochodowych jakości OEM, obsługujący aftermarket UK i Europy.",
      rangeOverline: "Produkty",
      rangeTitlePre: "Nasz",
      rangeTitleItalic: "asortyment",
      rangeSubtitle: "Trzy dywizje komponentów samochodowych jakości OEM — układy hamulcowe, części silnika i podwozia, opony i wyposażenie warsztatowe — dla aftermarketu UK i Europy.",
      contactOverline: "Kontakt",
      contactTitlePre: "Napisz do nas",
      contactTitleItalic: "wiadomość",
      contactSubtitle: "Zapytania aftermarket UK i Europy obsługujemy tego samego dnia roboczego. Wybierz wygodny dla siebie kanał.",
      qualityOverline: "Jakość",
      qualityTitlePre: "Jakość to",
      qualityTitleItalic: "łańcuch",
      qualityTitlePost: ", a nie slogan.",
      qualitySubtitle: "Pięć rygorystycznych etapów łączy fabrykę z Twoim zamówieniem — każdy krok z numerem partii, audytowany i odpowiedzialny.",
      quoteOverline: "Zapytanie o wycenę",
      quoteTitlePre: "Opowiedz nam o swoich",
      quoteTitleItalic: "wymaganiach",
      quoteSubtitle: "Podaj części i ilości. Odpowiemy w jeden dzień roboczy z dostępnością, terminem i ceną hurtową — bez zobowiązań.",
      breadcrumbHome: "Strona główna",
    },
  },
};
